import { useState, useMemo, useEffect, useCallback } from "react";
function useCountingQuiz({
  quizId,
  quiz,
  onSolve,
  solveResult,
  showReallyTrue = false,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  onAnswerChange
}) {
  const [startTime] = useState(() => Date.now());
  const [isShowingCorrectAnswers, setIsShowingCorrectAnswers] = useState(false);
  const isSolved = solveResult !== null && solveResult !== void 0;
  const shouldShowCorrectAnswers = showReallyTrue || isShowingCorrectAnswers;
  const correctDigits = useMemo(() => {
    var _a;
    const correctStr = (_a = solveResult == null ? void 0 : solveResult.correctAnswers) == null ? void 0 : _a[0];
    if (!correctStr) return null;
    return correctStr.split("").map(Number);
  }, [solveResult == null ? void 0 : solveResult.correctAnswers]);
  const computedInitialDigits = useMemo(() => {
    const numDigits = quiz.digits || 1;
    if (initialAnswersProp !== void 0) {
      const parsed = (initialAnswersProp[0] ?? "").split("").filter(Boolean).map(Number);
      if (parsed.length >= numDigits) return parsed.slice(0, numDigits);
      return [...parsed, ...Array(numDigits - parsed.length).fill(0)];
    }
    if (isViewSolved && correctDigits) {
      return correctDigits.slice(0, numDigits);
    }
    return Array(numDigits).fill(0);
  }, [quiz.digits, isViewSolved, correctDigits, initialAnswersProp]);
  const [digitValues, setDigitValues] = useState(computedInitialDigits);
  const canSubmit = true;
  const [hasInteracted, setHasInteracted] = useState(false);
  const showLottie = !isSolved && !isViewSolved && !hasInteracted && (!initialAnswersProp || initialAnswersProp.length === 0);
  const displayValues = useMemo(() => {
    if (shouldShowCorrectAnswers && correctDigits) {
      return correctDigits.slice(0, quiz.digits || 1);
    }
    return digitValues;
  }, [shouldShowCorrectAnswers, correctDigits, digitValues, quiz.digits]);
  useEffect(() => {
    onAnswerChange == null ? void 0 : onAnswerChange([digitValues.join("")]);
  }, [digitValues, onAnswerChange]);
  const handleUp = useCallback((index) => {
    if (isSolved || isViewSolved) return;
    setHasInteracted(true);
    setDigitValues((prev) => {
      const next = [...prev];
      next[index] = (next[index] + 1) % 10;
      return next;
    });
  }, [isSolved, isViewSolved]);
  const handleDown = useCallback((index) => {
    if (isSolved || isViewSolved) return;
    setHasInteracted(true);
    setDigitValues((prev) => {
      const next = [...prev];
      next[index] = (next[index] - 1 + 10) % 10;
      return next;
    });
  }, [isSolved, isViewSolved]);
  const handleSubmit = useCallback(() => {
    if (isSolved) return;
    const elapsedTime = Date.now() - startTime;
    const joinedAnswer = digitValues.join("");
    onSolve == null ? void 0 : onSolve(quizId, [joinedAnswer], quiz.vars, elapsedTime);
  }, [isSolved, startTime, digitValues, onSolve, quizId, quiz.vars]);
  const isDisabled = isSolved || isViewSolved;
  return {
    digitValues,
    displayValues,
    isSolved,
    canSubmit,
    shouldShowCorrectAnswers,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    correctDigits,
    showLottie,
    isDisabled,
    handleUp,
    handleDown,
    handleSubmit,
    quiz,
    quizId,
    solveResult,
    isViewSolved
  };
}
export {
  useCountingQuiz
};
//# sourceMappingURL=use-counting-quiz.js.map
